import React from 'react';
import { number, string } from 'prop-types';

// Utils
import { formatVolume } from 'utils/helpers/format';

// Components
import { addYears, format, lastDayOfMonth, subMonths } from 'date-fns';
import { Box, Divider, Typography } from '@mui/material';
import { InfoRounded } from '@mui/icons-material';
import * as styles from '../ConfirmSubscriptionCard.styles';

const TotalsSection = props => {
  const { effectiveDate, tierRate, tierVolume } = props;

  const effectiveDateObject = new Date(effectiveDate);
  const endDateOneYear = lastDayOfMonth(subMonths(addYears(effectiveDateObject, 1), 1));

  return (
    <Box mb={4} sx={styles.totalSection}>
      <Typography sx={styles.totalTitle} variant="subtitle1">
        Total
      </Typography>
      <Divider sx={styles.totalDivider} />
      <Box
        component="a"
        href="/downloads/HowWillIBeBilled_SwiftPlus_08262021.pdf"
        rel="noopener noreferrer"
        sx={styles.billingRulesButtonStyles}
        target="_blank"
      >
        <Typography
          sx={{
            color: 'primary.main',
            pr: 1,
            pt: '2px',
          }}
          variant="body2"
        >
          How will I be billed?
        </Typography>
        <InfoRounded sx={styles.infoIcon} />
      </Box>
      {/* This must be a box or the layout breaks */}
      <Box sx={styles.totalsContainer}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography sx={{ color: 'text.secondary' }} variant="body1">
            Fixed Cost
          </Typography>
          <Typography sx={{ color: 'primary.dark' }} variant="subtitle1">
            {`${formatVolume(tierVolume)} bbls @ $${tierRate}`}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography sx={{ color: 'text.secondary' }} variant="body1">
            Effective Date
          </Typography>
          <Typography sx={{ color: 'primary.dark' }} variant="subtitle1">
            {effectiveDate}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography sx={{ color: 'text.secondary' }} variant="body1">
            End Date
          </Typography>
          <Typography sx={{ color: 'primary.dark' }} variant="subtitle1">
            {format(new Date(endDateOneYear), 'MMMM d, yyyy')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

TotalsSection.propTypes = {
  effectiveDate: string.isRequired,
  tierRate: number.isRequired,
  tierVolume: number.isRequired,
};

export default TotalsSection;
